import moment from 'moment'

import { MISSION_STATUS_ENUM } from '../../shared/constants'
import { DATE_FORMAT } from '../../constants'
import { getDateOfISOWeek } from 'shared/libraries/utils/date'
/**
 * Formats items that will be displayed at the details section at the top of RosterView page
 * @param {array} param.missions Roster's missions
 * @param {number} param.week Roster's week
 * @param {number} param.year Roster's year
 *
 * @returns {array} Array of items that are ready to be consumed by the DetailsSection component
 */
export const getDetailsItems = ({ missions, week, year }) => {
  const missionsCount = missions.reduce((acc, mission) => {
    if (mission.cancelled) {
      acc[MISSION_STATUS_ENUM.CANCELLED] =
        (acc[MISSION_STATUS_ENUM.CANCELLED] || 0) + 1
    } else {
      acc[mission.status] = (acc[mission.status] || 0) + 1
    }
    return acc
  }, {})

  const staticItems =
    week && year
      ? [
          {
            label: 'Start Date',
            value: moment(getDateOfISOWeek(week, year)).format(DATE_FORMAT),
          },
          {
            label: '# Missions',
            value: missions.length,
          },
        ]
      : [
          {
            label: '# Missions',
            value: missions.length,
          },
        ]

  return Object.entries(missionsCount).reduce((acc, [status, count]) => {
    acc.push({
      label: `# ${status} Missions`,
      value: count,
    })
    return acc
  }, staticItems)
}



// WEBPACK FOOTER //
// ./src/Components/DetailsSection/utils.js